import { useEffect, useState } from "react";
import { adminApi, errMsg } from "../api";
import { SaveBar, Toggle } from "../components";
import { toast } from "../../components/ui/sonner";

export default function NavigationAdmin() {
  const [nav, setNav] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { adminApi.get("/settings").then((r) => setNav(r.data.navigation || [])).catch((e) => toast.error(errMsg(e))); }, []);
  if (!nav) return <div className="adm-empty">Loading…</div>;

  const setTop = (i, patch) => setNav(nav.map((n, j) => (j === i ? { ...n, ...patch } : n)));
  const setChild = (i, k, patch) =>
    setNav(nav.map((n, j) => (j === i ? { ...n, children: n.children.map((c, l) => (l === k ? { ...c, ...patch } : c)) } : n)));

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.put("/admin/settings", { navigation: nav });
      toast.success("Navigation saved");
    } catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-navigation-page">
      <div className="adm-head">
        <div><h1>Navigation</h1><div className="sub">Edit labels and visibility (structure is fixed)</div></div>
        <SaveBar onSave={save} saving={saving} testid="save-navigation" />
      </div>
      {nav.map((n, i) => (
        <div className="adm-card" key={n.path}>
          <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" }}>
            <input style={{ maxWidth: 220, fontWeight: 600 }} className="mono-input" value={n.label}
              onChange={(e) => setTop(i, { label: e.target.value })} data-testid={`nav-label-${n.path.replace(/\//g, "") || "home"}`} />
            <span className="mono">{n.path}</span>
            <Toggle checked={n.visible !== false} onChange={(v) => setTop(i, { visible: v })} label={n.visible !== false ? "Visible" : "Hidden"} testid={`nav-visible-${n.path.replace(/\//g, "") || "home"}`} />
          </div>
          {n.children?.length > 0 && (
            <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
              {n.children.map((c, k) => (
                <div key={c.path} style={{ display: "flex", gap: 10, alignItems: "center", paddingLeft: 18, flexWrap: "wrap" }}>
                  <input style={{ maxWidth: 300 }} value={c.label} onChange={(e) => setChild(i, k, { label: e.target.value })} />
                  <input style={{ flex: 1, minWidth: 220 }} value={c.description || ""} placeholder="Short description" onChange={(e) => setChild(i, k, { description: e.target.value })} />
                  <span className="mono">{c.path}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      <SaveBar onSave={save} saving={saving} testid="save-navigation-bottom" />
    </div>
  );
}
